import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

const AdminLoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  async function submit(e) {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError("");
    try {
      await axios.post(
        `${API}/auth/login`,
        { email, password },
        { withCredentials: true }
      );
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <section className="bg-[#121212] text-white min-h-screen flex items-center" data-testid="admin-login-page">
      <div className="max-w-md mx-auto px-6 w-full">
        <div className="mb-10">
          <img src="/brand/logo.webp" alt="#whatshesaidproject" className="h-10 w-auto mb-6" />
          <span className="text-xs font-mono uppercase tracking-[.18em] text-[#e02020] block mb-2">
            Studio
          </span>
          <h1 className="font-disp text-3xl text-white">Sign in to manage the site.</h1>
        </div>
        <form data-testid="admin-login-form" onSubmit={submit} className="space-y-6">
          <div>
            <label htmlFor="admin-email" className="block text-xs font-mono uppercase tracking-[.14em] text-[#b5b5b5] mb-2">
              Email Address
            </label>
            <input
              id="admin-email"
              data-testid="admin-email-input"
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full bg-[#1c1c1c] border border-[#333333] text-white px-4 py-3 text-sm focus:border-[#e02020] focus:outline-none rounded-none"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="block text-xs font-mono uppercase tracking-[.14em] text-[#b5b5b5] mb-2">
              Password
            </label>
            <input
              id="admin-password"
              data-testid="admin-password-input"
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full bg-[#1c1c1c] border border-[#333333] text-white px-4 py-3 text-sm focus:border-[#e02020] focus:outline-none rounded-none"
            />
          </div>
          {error && (
            <p data-testid="admin-login-error" role="alert" className="text-sm text-[#e02020]">
              {error}
            </p>
          )}
          <button
            type="submit"
            data-testid="admin-login-submit"
            disabled={busy}
            className="w-full py-4 bg-[#e02020] text-white text-xs font-mono uppercase tracking-[.16em] hover:bg-white hover:text-[#121212] transition-colors font-semibold rounded-none disabled:opacity-60"
          >
            {busy ? "Signing In…" : "Sign In"}
          </button>
        </form>
      </div>
    </section>
  );
};

export default AdminLoginPage;
